import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {VisuallyHidden} from '../../../../libs/shared/ui/src/components/visuallyHidden/visuallyHidden';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface DropdownItemIconProps {
  label: ReactNode;
  iconName?: IconName;
  color?: string;
  iconSize?: number;
  className?: string;
}

/*
 * Style.
 */

interface IconStyleProps {
  $color: string;
}
const StyledIconDiv = styled.div<IconStyleProps>`
  grid-area: left-icon;
  margin-right: 8px;
  align-self: center;
  color: ${(p) => p.$color};
`;

/*
 * Component.
 */

export const DropdownItemIcon: FC<DropdownItemIconProps> = ({
  label,
  iconName,
  color,
  iconSize,
  children,
  className,
}) => {
  const theme = useUserTheme();

  return (
    <StyledIconDiv $color={color || theme.greys.shade70} className={className}>
      {iconName ? <Icon name={iconName} size={iconSize || 20} /> : children}
      <VisuallyHidden>{label}</VisuallyHidden>
    </StyledIconDiv>
  );
};
